<template>
  <div class="files-tab">
    <div class="info-block">
      <h5 class="title_public">{{ $t('Bill of quantities') }}</h5>
      <DownloadFile
        :file="{ name: offerXlsxTemplateFilename }"
        :is-extended="true"
        :is-loading="loadings.includes('offerXlsxTemplate')"
        trigger-download-in-parent
        @click.native.stop="downloadXlsxHandler({ loadingId: 'offerXlsxTemplate' })"
      />
    </div>
    <div v-if="get(publicTenderInfo, 'files.length')" class="d-contents">
      <div class="info-block info-block_attached">
        <h5 class="title_public">{{ $t('Attached files') }}</h5>
        <div class="files-wrap">
          <DownloadFile
            v-for="file in publicTenderInfo.files"
            :key="file.id"
            :file="file"
            :is-extended="true"
          />
        </div>
      </div>
      <div class="inline-wrap">
        <Button
          type="secondary"
          icon="download"
          size="small"
          @click.native.stop="downloadAllFilesHandler('downloadAll')"
        >
          <Spinner v-if="loadings.includes('downloadAll')" size="16" />
          <span v-else>{{ $t('Download all') }}</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
  import DownloadFile from '@/components/files/DownloadFile';
  import Button from '@/components/ui-v2/Button';
  import get from 'lodash.get';
  import { mapActions, mapState } from 'vuex';
  import Spinner from 'vue-simple-spinner';

  export default {
    name: 'FilesTabOfPublicTender',
    components: {
      DownloadFile,
      Button,
      Spinner,
    },
    computed: {
      ...mapState('publicTender', ['loadings', 'publicTenderInfo', 'offerXlsxTemplateFilename']),
    },
    methods: {
      get,
      ...mapActions('publicTender', ['downloadAllFilesHandler', 'downloadXlsxHandler']),
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
